var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.3,
    height: 58.288,
    viewBox: "0 0 64.3 58.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_42",
    "data-name": "Komponente 10 \\u2013 42",
    transform: "translate(0.15 0.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line-chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46876",
    "data-name": "Pfad 46876",
    d: "M60.056,94.06A3.931,3.931,0,0,1,57.2,92.829l-7.38,4.217A3.944,3.944,0,1,1,43.29,95.3L33.12,77.864a3.93,3.93,0,0,1-2.936-.282L21.2,87.852a3.943,3.943,0,1,1-5.695-.809L4.714,63.923a3.953,3.953,0,1,1,1.7-.8L17.2,86.248a3.933,3.933,0,0,1,2.586.369l8.986-10.27a3.943,3.943,0,1,1,5.965.57l10.17,17.434a3.933,3.933,0,0,1,3.978,1.068l7.38-4.217a3.943,3.943,0,1,1,3.79,2.858ZM3.943,57.987a2.069,2.069,0,1,0,2.069,2.069A2.071,2.071,0,0,0,3.943,57.987ZM15.9,90.116a2.069,2.069,0,1,0,2.069-2.069A2.071,2.071,0,0,0,15.9,90.116ZM32,72.015a2.069,2.069,0,1,0,2.068,2.068A2.071,2.071,0,0,0,32,72.015ZM46.028,96.064A2.069,2.069,0,1,0,48.1,98.132,2.071,2.071,0,0,0,46.028,96.064Zm14.028-8.016a2.069,2.069,0,1,0,2.069,2.069A2.071,2.071,0,0,0,60.056,88.048Z",
    transform: "translate(0 -52.104)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46877",
    "data-name": "Pfad 46877",
    d: "M81.1,192.388h2.068V153.245a.938.938,0,0,1,1.875,0v39.143H97.2V181.3a.937.937,0,1,1,1.875,0v11.087h12.153V165.269a.937.937,0,1,1,1.875,0v27.119h12.153v-3.07a.938.938,0,0,1,1.875,0v3.07H133.2a.938.938,0,0,1,0,1.875H81.1a.938.938,0,0,1,0-1.875Z",
    transform: "translate(-80.161 -136.275)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46878",
    "data-name": "Pfad 46878",
    d: "M.938,388.783H3.006V377.7a.938.938,0,0,1,1.875,0v11.087H6.95a.938.938,0,0,1,0,1.875H.938a.938.938,0,0,1,0-1.875Z",
    transform: "translate(56.112 -332.67)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46879",
    "data-name": "Pfad 46879",
    d: "M249.438,138.149a.938.938,0,1,1,0-1.875h.01a.938.938,0,0,1-.01,1.875Z",
    transform: "translate(-217.443 -122.246)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46880",
    "data-name": "Pfad 46880",
    d: "M24.945,266.407a.938.938,0,1,1,0-1.875h.01a.938.938,0,0,1-.01,1.875Z",
    transform: "translate(35.111 -234.471)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46881",
    "data-name": "Pfad 46881",
    d: "M473.929,25.923a.938.938,0,0,1,0-1.875h.01a.938.938,0,1,1-.01,1.875Z",
    transform: "translate(-469.996 -24.048)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46882",
    "data-name": "Pfad 46882",
    d: "M137.251,330.536a.938.938,0,1,1,0-1.875h.01a.938.938,0,0,1-.01,1.875Z",
    transform: "translate(-91.233 -290.584)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46883",
    "data-name": "Pfad 46883",
    d: "M361.662,266.407a.938.938,0,0,1,0-1.875h.01a.938.938,0,1,1-.01,1.875Z",
    transform: "translate(-343.696 -234.471)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.9b9cf34a210cd261d1b131f70bbad626.svg";
export { ForwardRef as ReactComponent };